import React from 'react';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';
import { ReactComponent as CheckIcon } from '@lifesize/ux-assets/vectors/svgIcons/check.svg';
import classes from './AddParticipantDrawer.module.scss';

const FileCopiedIndicator = () => (
  <div className={clsx(classes.copyButton, classes.copied)}>
    <CheckIcon className={classes.icon} />
    <FormattedMessage id="components.inCallDrawer.item.copied" defaultMessage="copied" />
  </div>
);

export default FileCopiedIndicator;
